<!-- @format -->

<upload-page>
  <style>
    .switchArea * {
      cursor: pointer;
    }
    .tooltip-wrap {
      display: flex;
    }
  </style>

  <div class="wrapper app" if="{state.debt_note}">
    <section class="form_wrap">
      <div class="form_inner important">
        <h1 class="main_title app">重要なご連絡</h1>

        <p>
          ご利用分のお支払いがエラーにより完了していないため、
          <span class="emphasis">サービスのご利用を停止</span>
          しております。
        </p>
        <p>
          <a href="/setting/status" style="color: red">こちらの画面</a>
          より、未払いの料金のお支払いに進んでください。
        </p>
        <div class="unpaid">
          <p style="margin: 20px 0 20px 0">未払いの内容：{state.debt_note}</p>
        </div>
        <p>
          ※お支払いが完了しましたらフリープランの状態になりますので、
          <br />
          引き続き有料プランをご利用されたい場合は改めて有料プランをご契約ください。
        </p>
      </div>
    </section>
  </div>

  <div class="wrapper app" if="{!state.debt_note}">
    <section class="form_wrap">
      <div class="form_inner">
        <form action="" class="">
          <section class="acquisition_area">
            <h1 class="main_title app">
              一括で取得したい文章を選択してください。
            </h1>

            <div class="acquisition-container">
              <div class="tooltip-wrap">
                <h2 class="sub_title app">
                  ファイルからテキストを取得する（対応拡張子：txt / docx / xlsx
                  / pptx / pdf)
                </h2>
                <tooltip
                  text="特定のファイルを指定して、ファイル内のテキストを取得します。<br>複数のファイルを指定して一括でテキストを取得することができるので、その場合は都度「＋ファイルをアップロード」を押して、ファイルを追加してください。<br>20000文字以上を超える場合や指定されたファイルの内容によっては正常に取得できない可能性があります。"
                ></tooltip>
              </div>

              <div class="upload_container">
                <button
                  class="button button-tertiary button-add upload js-add"
                  type="button"
                  value="ファイルをアップロード"
                  onclick="{ onFile }"
                >
                  ファイルをアップロード
                </button>
                <input
                  style="display: none"
                  type="file"
                  name="file"
                  onchange="{ onAddFile }"
                  multiple="multiple"
                  accept="text/plain,.docx,.xlsx,.pptx,.pdf"
                />
              </div>
              <!--/.upload_container-->
              <div
                class="url_wrap domain-url active"
                each="{ (file, i) in state.upload.files }"
              >
                <input
                  type="text"
                  name="file[{i}]"
                  class="url-input url-acquired"
                  size="67"
                  maxlength=""
                  value="{ file.name }"
                />
                <button
                  class="button button-clear js-clear"
                  type="button"
                  value="クリア"
                  onclick="{ e => onRemoveFile(e, i) }"
                >
                  クリア
                </button>
              </div>
              <div if="{ state.errors.files }" class="err-msg is-active">
                { state.errors.files }
              </div>
            </div>

            <!--/.acquisition-container-->

            <div class="acquisition-container">
              <div class="tooltip-wrap">
                <h2 class="sub_title app">URLからテキストを取得する</h2>
                <tooltip
                  text="特定のWEBページのURLを指定して、ページ内のテキストを取得します。<br>複数のURLを指定して一括でテキストを取得することができるので、その場合は「＋追加する」を押してください。<br>20000文字以上を超える場合や指定されたWEBページの設計によっては正常に取得できない可能性があります。"
                ></tooltip>
              </div>

              <div class="url_container">
                <div
                  class="url_wrap domain-url active"
                  each="{ (url, i) in state.upload.urls }"
                >
                  <input
                    type="text"
                    name="url[{i}]"
                    class="url-input url-acquired"
                    value="{url}"
                    readonly
                  />
                  <button
                    class="button button-clear"
                    type="button"
                    value="クリア"
                    onclick="{ e => onRemoveUrl(e, i) }"
                  >
                    クリア
                  </button>
                </div>
                <div class="url_wrap">
                  <input type="text" name="url" class="url-input" />
                  <button
                    class="button button-tertiary button-add js-add"
                    type="button"
                    value="追加する"
                    onclick="{ onAddUrl }"
                  >
                    追加する
                  </button>
                  <div if="{ state.errors.urls }" class="err-msg is-active">
                    { state.errors.urls }
                  </div>
                </div>
                <!--/.url_wrap-->
              </div>
              <!--/.url_container-->
            </div>
            <!--/.acquisition-container-->

            <button
              class="button button-primary sub js-shutoku"
              type="button"
              value="テキストを一括取得"
              onclick="{ onLumpRequest }"
            >
              テキストを一括取得
            </button>
          </section>
          <!--/.acquisition_area-->

          <section if="{ state.list.length > 0 }" class="analysis_area is-show">
            <h1 class="main_title app">
              一括で解析したい文章を選択してください。
            </h1>

            <div class="analysis-table-wrap">
              <table class="analysis-table">
                <thead class="analysis-heading">
                  <tr>
                    <th class="lump_check">
                      <input
                        type="checkbox"
                        name="csv-check_all"
                        value="csv-check_all"
                        id="csv-check_all"
                        class="checkbox-input"
                        onchange="{ onCheckAll }"
                      />
                      <label for="csv-check_all" class="checkbox-parts"></label>
                    </th>
                    <th class="lump_title">ファイル名 または URL</th>
                    <th class="lump_number">文字数</th>
                    <th class="lump_count">消費カウント</th>
                    <th class="lump_txt">取得テキスト</th>
                  </tr>
                </thead>
                <tbody class="analysis-contents">
                  <tr
                    each="{ (item, i) in state.list }"
                    class="{ item.id ? '' : 'over' }"
                  >
                    <td class="lump_check">
                      <input
                        if="{ item.id }"
                        type="checkbox"
                        name="checked"
                        id="csv-check-{i}"
                        class="checkbox-input"
                        is="binding"
                        data="{ item }"
                        val="{ item.id }"
                        checked="{ !!item.checked }"
                      />
                      <label
                        if="{ item.id }"
                        for="csv-check-{i}"
                        class="checkbox-parts history-list_check"
                      ></label>
                    </td>
                    <td class="lump_title">
                      { item.title.replace(/^(.{36})(.*)/, (a,b) => b + '...' )
                      }
                    </td>
                    <td class="lump_number">
                      <span class="emphasis">{ item.length }</span>
                    </td>
                    <td class="lump_count">
                      <span class="emphasis">{ item.count }</span>
                    </td>
                    <td class="lump_txt">{ item.text }</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--/.analysis-table-wrap-->

            <div class="similar_wrap">
              <div class="similar_heading">
                <span>類似チェック</span>
                <tooltip
                  text="言い回しを変えただけ、安易にリライトしただけの“書いてある内容は同じ”文章も検出します。<br>コピペチェックに加えて類似チェックを行う場合は右にあるスイッチを「ON」にして「解析内容の確認」のボタンを押してください。<br>※類似チェックを行いたい場合は、通常のチケット消費×２のカウント消費が必要になります。"
                ></tooltip>
                <!--	/.tooltip_container-->
              </div>
              <div
                class="switchArea"
                onclick="{ e => $(`input[name='similarityCheck']`).click() }"
              >
                <input
                  type="checkbox"
                  name="similarityCheck"
                  is="binding"
                  data="{ state }"
                  val="1"
                />
                <label><span></span></label>
                <div id="swImg"></div>
              </div>
            </div>
            <!--/.similar_wrap-->

            <button
              class="button button-primary js-modal-open"
              type="button"
              value="解析内容の確認"
              data-target="modal01"
              onclick="{ onConfirm }"
            >
              解析内容の確認
            </button>
          </section>
          <!--/.analysis_area-->
        </form>
      </div>
      <!--/.form_inner-->
    </section>
    <!--form_wrap-->
  </div>
  <!--/.wrapper-->

  <ticket-modal
    modal-id="{ modalId }"
    ticket-require="{ state.ticketRequire }"
    similarity-check="{ state.similarityCheck }"
    on-start-processing="{ onStartProcessing }"
  ></ticket-modal>

  <script>
    import di from "dependeny-injection";
    import tooltip from "@tags/parts/tooltip.riot";
    import ticketModal from "@tags/modal/ticket-modal.riot";
    import { Upload, TicketRequire, api as UploadApi } from "@model/inputs.js";
    import routes from "@model/routes.js";

    export default {
      components: {
        tooltip,
        "ticket-modal": ticketModal,
      },
      modalId: "upload-modal",
      onBeforeMount() {
        this.routes = routes;
        this.state = {
          errors: {},
          upload: new Upload(),
          list: [],
          ticketRequire: new TicketRequire(),
          similarityCheck: "",
          debt_note: di.userStatusApi.debt_note,
        };
      },
      onMounted() {
        di.userStatusApi.on("fetched", (data) => {
          this.update({ debt_note: data.debt_note });
        });
      },
      onFile(e) {
        e.target.value = "";
        this.$('input[name="file"]').click();
      },
      onAddFile(e) {
        if (e.target.value) {
          this.state.upload.addFile(e.target.files);
          e.target.value = "";
        }
        this.update();
      },
      onRemoveFile(e, index) {
        this.state.upload.files.splice(index, 1);
        this.update();
      },
      onAddUrl(e) {
        this.state.errors.urls = this.state.upload.addUrl(
          this.$('input[name="url"]').value
        );
        this.update();
        this.$('input[name="url"]').value = "";
      },
      onRemoveUrl(e, index) {
        this.state.upload.urls.splice(index, 1);
        this.update();
      },
      async onLumpRequest() {
        const errors = this.state.upload.valid();
        if (Object.entries(errors).length > 0) {
          this.update({ errors });
          di.toast.push(Object.values(errors).join(""), "negative");
          return;
        }
        di.loader.setState(true);
        const res = await UploadApi.requestTexts(this.state.upload);
        this.update({ list: res.list, errors: {} });
        di.loader.setState(false);
      },
      onCheckAll(e) {
        for (const item of this.state.list) {
          item.checked = e.target.checked ? item.id : "";
        }
        this.update({ list: this.state.list });
      },
      async onConfirm(e) {
        this.state.ticketRequire.setUploadList(
          this.state.list,
          this.state.similarityCheck,
          di.userStatusApi.info.aquiredTickets
        );

        this.update({ ticketRequire: this.state.ticketRequire });
        window.$(this.$(`#${this.modalId}`)).fadeIn(100);
      },
      async onStartProcessing(e) {
        di.loader.setState(true);
        const res = await UploadApi.register(
          this.state.ticketRequire.ids,
          [],
          this.state.similarityCheck
        );
        if (res && res.success) {
          di.toast.push("解析を受け付けました。", "success");
          window.$(this.$(`#${this.modalId}`)).fadeOut(0);
          di.router.push(this.routes.makePath("upload-registered-page"));
        } else {
          if (res) {
            this.state.ticketRequire.msg = res.msg;
            this.update({ ticketRequire: this.state.ticketRequire });
          }
          di.toast.push(
            res && res.msg ? res.msg : "エラーが発生しました。",
            "negative"
          );
        }
        di.userStatusApi.fetch();
        di.loader.setState(false);
      },
    };
  </script>
</upload-page>
